<template>
  <div class="template" v-if="isValidPage">
    <section class="container">
      <LoadingOutlined class="loading" v-if="loading" />

      <template v-else>
        <p class="title">Conecta con Facebook Messenger</p>
        <p class="description">
          Comienza a comunicarte con tus clientes a través de Facebook Messenger
        </p>
        <img src="@/app/shared/assets/characters/sergio.png" alt="sergio" />
        <a-button type="primary" @click="handleLogin">
          <FacebookOutlined theme="filled" />
          Conectar con Facebook
        </a-button>
      </template>
    </section>
  </div>

  <h1 v-else>No user credentials</h1>
</template>

<script>
import { defineComponent } from "vue";
import { loadFacebook } from "@/app/shared/utils/loadFacebook";
import { FacebookOutlined, LoadingOutlined } from "@ant-design/icons-vue";
import { tokenManager } from "@/app/shared/utils/tokenManager";
import httpManager from "@/app/shared/utils/httpManager";

export default defineComponent({
  components: {
    FacebookOutlined,
    LoadingOutlined,
  },
  beforeCreate() {
    loadFacebook();
  },
  data() {
    return {
      workspace: "",
      accessToken: null,
      loading: false,
      userId: null,
      userFullname: "",
      tenantUrl: null,
    };
  },
  computed: {
    isValidPage() {
      return this.accessToken && this.workspace;
    },
  },
  mounted() {
    this.accessToken = this.$route.query.access_token;
    this.workspace = this.$route.query.workspace;
    this.userId = this.$route.query.userId;
    this.userFullname = this.$route.query.userFullname;

    this.tenantUrl =
      window.location.hostname == "localhost"
        ? "https://localhost:8080"
        : `https://${this.workspace}.${import.meta.env.VITE_HOSTNAME}`;

    if (this.isValidPage) {
      tokenManager.saveToken(this.accessToken);
      httpManager.updateBaseURL(
        `https://${this.workspace}.backend.${import.meta.env.VITE_HOSTNAME}`
      );
    } else {
      this.$message.error(
        "No es posible iniciar el proceso de vinculacion de Facebook, por favor intente nuevamente."
      );
      var eventError = new CustomEvent("facebookHandler", { detail: { integration: false } });
      window.parent.document.dispatchEvent(eventError);
    }
  },
  methods: {
    async handleLogin() {
      try {
        this.loading = true;
        await this.$store.dispatch("loginWithFacebook", {
          id: this.userId,
          fullname: this.userFullname,
        });
        this.$message.success("Logueado correctamente");
        window.parent.postMessage("success", this.tenantUrl);
      } catch (error) {
        const errorMessage = error?.message || "Algo salió mal, por favor vuelve a intentarlo";
        this.$message.warning(errorMessage);

        if (error?.error) console.log(error?.error);
      }

      this.loading = false;
    },
  },
});
</script>

<style lang="sass" scoped>
.template
  height: 100vh
.container
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  height: 100%
.title
  font-weight: 600
  font-size: $font-large
  line-height: 28px
  text-align: center
  color: $gray-9
  margin-bottom: $margin-tiny

.description
  font-size: $font-normal
  line-height: 22px
  text-align: center
  color: $gray-9
.link
  color: $blue-6
  margin-bottom: 0px
  margin-left: $margin-tiny
  font-weight: normal

.loading
  font-size: 3rem
</style>
